export const CREATE_UNIT_INCOME_RECORD = "CREATE_UNIT_INCOME_RECORD";
export const FETCH_UNIT_INCOME_RECORDS = "FETCH_UNIT_INCOME_RECORDS";
export const FETCH_UNIT_INCOME_RECORD = "FETCH_UNIT_INCOME_RECORD";
export const EDIT_UNIT_INCOME_RECORD = "EDIT_UNIT_INCOME_RECORD";
export const DELETE_UNIT_INCOME_RECORD = "DELETE_UNIT_INCOME_RECORD";
